import { render, staticRenderFns } from "./EmAttachmentEdit.vue?vue&type=template&id=523f179c&"
import script from "./EmAttachmentEdit.vue?vue&type=script&lang=js&"
export * from "./EmAttachmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports